import React from "react";
import SearchDropDown from "../common/SearchDropDown";
import { USER_TYPE } from "../../constant";

export default function EmployerSearch( {val, setVal} ) {

  return (
    <SearchDropDown
      mode="multiple"
      val={val}
      setVal={setVal}
      placeholder="Select users"      
      type={USER_TYPE.EMPLOYER}
      style={{
        width: "100%",
      }}
    />
  );
}
